import type { Interview } from "@shared/schema";

export type InterviewContextLabel =
  | "Não comunicado"
  | "Aguardando Agendamento"
  | "Agendado"
  | "Entrevistando"
  | "Aguardando Avaliação"
  | "Finalizado";

const neutralBorder = "border-stone-300 text-stone-600 dark:border-stone-600 dark:text-stone-400";

export const interviewStatusColors: Record<string, string> = {
  "Não comunicado": neutralBorder,
  "Aguardando Agendamento": neutralBorder,
  Agendado: neutralBorder,
  Entrevistando: neutralBorder,
  "Aguardando Avaliação": neutralBorder,
  Finalizado: neutralBorder,
};

export function getInterviewContextStatus(interview: Interview): InterviewContextLabel {
  const status = interview.status || "pending";
  const now = new Date();

  if (interview.interviewerGroupId) {
    if (interview.completedAt) return "Finalizado";
    if (status === "finished") return "Aguardando Avaliação";
  } else {
    const hasFeedback = !!interview.gcaVerdict || !!interview.recommendation;
    if (hasFeedback) return "Finalizado";
    if (status === "finished") return "Aguardando Avaliação";
  }

  if (status === "scheduled") {
    if (interview.scheduledAt) {
      const start = new Date(interview.scheduledAt);
      const end = interview.scheduledEndAt ? new Date(interview.scheduledEndAt) : null;
      if (end && now >= start && now <= end) {
        return "Entrevistando";
      }
    }
    return "Agendado";
  }

  return interview.candidateNotifiedAt ? "Aguardando Agendamento" : "Não comunicado";
}

export function isSchedulingOverdue(interview: Interview, notifyHmDailyDigest: boolean): boolean {
  const label = getInterviewContextStatus(interview);
  if (label !== "Aguardando Agendamento") return false;
  if (!interview.candidateNotifiedAt) return false;

  const notifiedAt = new Date(interview.candidateNotifiedAt);
  const now = new Date();
  const daysSince = (now.getTime() - notifiedAt.getTime()) / (1000 * 60 * 60 * 24);
  const threshold = notifyHmDailyDigest ? 3 : 2;
  return daysSince >= threshold;
}
